




























import Vue from 'vue'

export default Vue.extend({
  name: 'CookieConsent',
  data: () => ({
    cookieConsent:
      localStorage.getItem('cookieConsent') === 'confirmed' ? false : true,
  }),
  methods: {
    saveCookieConsent: function () {
      localStorage.setItem('cookieConsent', 'confirmed')
      this.cookieConsent = false
    },
  },
})
